import * as React from 'react';
import { connect, useSelector } from 'react-redux';
import cn from 'classnames';
import Passenger from '../../../../../PassengerForm/components/PassengerForm';
import { InputType } from '../../../../../Passenger/types';
import { useTheme } from '../../../../../theme';
import memes from '../../../../../memes';
import { getPassengerLabels } from '../../../../store/passengers/selectors';
import { getIsNew, getIsReadonly, getServices, getMessages } from '../../../../store/order/selectors';
import { getPassengerStateCompatible } from '../../../../store/selectedServices/selectors';
import { useRenderers } from '../../../../../renderProps';
import PassengerSubsidy from './PassengerSubsidy/PassengerSubsidy';
import { TravellerFieldEnum } from '@websky/graphql';
import LoyaltyConnect, { ConnectType } from '../../../../../Loyalty/components/LoyaltyStub/LoyaltyConnect/LoyaltyConnect';
import { getUserInfo } from '../../../../utils';
import DisabilitiesContextProvider from '../../../../../PassengerForm/components/components/Disabilities/context';
import { useConfigRedirects } from '../../../../../hooks';
import { usePassengers } from './hooks';
import { getSubsidiesByPassengers } from '../../../../store/subsidies/selectors';
export const getInputType = memes((type) => {
    switch (type) {
        case TravellerFieldEnum.Gender:
            return InputType.Switch;
        case TravellerFieldEnum.Phone:
            return InputType.Phone;
        case TravellerFieldEnum.BirthDate:
        case TravellerFieldEnum.DocExpiryDate:
            return InputType.Date;
        case TravellerFieldEnum.LoyaltyAirline:
        case TravellerFieldEnum.DocType:
            return InputType.Select;
        case TravellerFieldEnum.FirstName:
        case TravellerFieldEnum.LastName:
            return InputType.Autocomplete;
        case TravellerFieldEnum.Nationality:
            return InputType.Nationality;
        default:
            return InputType.Text;
    }
});
const Passengers = ({ className, passengersState, isReadonly, isNew, isAuthorized, fields, services, onFill, hideClearButton, labels, isInputsReadonly, inModal, isChangePassengers, orderSubsidies, backToResults, autofocus, showLoginForm, userInfo, refetchUser, isLoginFormOpen, isChangeFiles, selectedProfileIdsByPassenger, onSwap, onToggleChangeFiles, onChangeFormSubscription }) => {
    const theme = useTheme('Checkout').PassengersStyles;
    const { CheckoutFormPassenger = Passenger } = useRenderers();
    const [openedPassengerFormId, setOpenedPassengerFormId] = React.useState(0);
    const [mobileOpenedPassengerId, setMobileOpenedPassengerId] = React.useState(null);
    const [loginBeforeCreateLoyaltyAccount, setLoginBeforeCreateLoyaltyAccount] = React.useState(false);
    const [loyaltyConnectOpen, setLoyaltyConnectOpen] = React.useState(false);
    const subsidiesByPassengers = useSelector(getSubsidiesByPassengers);
    const orderMessages = useSelector(getMessages);
    const { travellersMap, passengerLabelMap, passengerFieldsMap, servicesPricesMap, accompanyingFields } = usePassengers({
        fields,
        labels,
        services,
        passengersState,
        isChangePassengers,
        onChangeFormSubscription,
        availableSubsidies: subsidiesByPassengers,
        isAuthorized
    });
    const { onGoToAccountSettings } = useConfigRedirects();
    const onCorrectFormFilledHandler = (passengerId) => {
        if (passengerId + 1 > openedPassengerFormId) {
            setOpenedPassengerFormId(passengerId + 1);
        }
    };
    const onSignUpLoyaltyProgram = () => {
        if (!isAuthorized) {
            setLoginBeforeCreateLoyaltyAccount(true);
            showLoginForm();
        }
        else {
            setLoyaltyConnectOpen(true);
        }
    };
    React.useEffect(() => {
        if (isAuthorized && loginBeforeCreateLoyaltyAccount && userInfo.isFfpAuthorizationNeeded) {
            setLoyaltyConnectOpen(true);
        }
    }, [loginBeforeCreateLoyaltyAccount, isAuthorized]);
    React.useEffect(() => {
        if (!isLoginFormOpen) {
            setLoginBeforeCreateLoyaltyAccount(false);
        }
    }, [isLoginFormOpen]);
    const onLoyaltyCardSaved = () => {
        setLoyaltyConnectOpen(false);
        refetchUser();
    };
    return (React.createElement("div", { className: cn(theme.passengers, { [theme.passengers_readonly]: isReadonly }) }, fields.map((passenger, passengerId) => {
        var _a;
        const label = passengerLabelMap.get(passengerId);
        const passengerFields = passengerFieldsMap.get(passengerId);
        const servicesPrice = servicesPricesMap.get(passengerId);
        const traveller = travellersMap.get(passenger.id);
        const profileId = selectedProfileIdsByPassenger.get(passengerId);
        const passAccompanyingFields = passengerId + 1 === travellersMap.size ? accompanyingFields : [];
        return (React.createElement(DisabilitiesContextProvider, { value: {
                availableDisabilities: passenger.availableDisabilities,
                passengerId
            }, key: passenger.id },
            React.createElement(PassengerSubsidy, { passengerId: passenger.id, subsidyInfo: (_a = traveller.subsidyInfo) === null || _a === void 0 ? void 0 : _a.subsidies, fields: traveller.values, orderSubsidyState: orderSubsidies, backToResults: backToResults }, props => (React.createElement(CheckoutFormPassenger, { hideClearButton: hideClearButton, key: passengerId, className: className, id: passengerId, onFill: (values, fieldValue) => {
                    onFill(values, passengerId, fieldValue);
                }, fields: passengerFields, passengerType: passenger.type, supplierType: passenger.supplierTravellerType, selectedProfileId: profileId, isReadonly: isReadonly, isAuthorized: isAuthorized, isChangePassengers: isChangePassengers, servicesTotalPrice: servicesPrice, withSubsidies: props.withSubsidy, noSubsidyAvailable: props.noSubsidyAvailable, subsidyRejectMessage: props.subsidyRejectMessage, label: label, isInputsReadonly: isInputsReadonly, onCorrectFilled: onCorrectFormFilledHandler, open: !isNew || inModal || passengerId <= openedPassengerFormId, mobileOpenedPassengerId: mobileOpenedPassengerId, onSetMobileOpenedPassengerId: setMobileOpenedPassengerId, needOthsSsr: passenger.needOthsSsr, autofocus: autofocus && passengerId === 0, isChangeFiles: isChangeFiles, accompanyingFields: passAccompanyingFields, onSignUpLoyaltyProgram: onSignUpLoyaltyProgram, onSwap: onSwap ? () => onSwap(passengerId) : null, onToggleChangeFiles: onToggleChangeFiles, infoMessages: orderMessages }))),
            React.createElement(LoyaltyConnect, { isOpen: loyaltyConnectOpen, type: ConnectType.Login, userInfo: getUserInfo(userInfo), showRegisterAction: true, onLoyaltyCardSaved: onLoyaltyCardSaved, onClose: () => setLoyaltyConnectOpen(false), onGoToSettings: onGoToAccountSettings })));
    })));
};
const mapStateToProps = (state, ownProps) => {
    return Object.assign(Object.assign({}, ownProps), { labels: getPassengerLabels(state), passengersState: getPassengerStateCompatible(state), services: getServices(state), isNew: getIsNew(state), isReadonly: getIsReadonly(state) });
};
export default connect(mapStateToProps)(Passengers);
